import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NewsService } from '../services/news.service';
import { Member } from '../models/member';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Category } from '../models/category';
import { Subcategory } from '../models/subcategory';

@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})
export class QueryComponent implements OnInit {

  public oldCategories: any[] = []
  public display_results: any[] = []

  constructor(
    private db: AngularFirestore,
    private fs: AngularFireStorage,
    public _newsService: NewsService,
  ) {

    //this.loadOldCategories();
  }

  ngOnInit() {
  }



  _runQuery() {

    let array: any[] = [];

    return this.db.collection<Member>('sbccv_members').ref.orderBy("name", "asc")
      .get()
      .then((result) => {

        result.forEach((item) => {

          console.log()
          // CURRENT ID
          const doc_id = item.id;
          const data = item.data();

          let new_category: any = {};

          let old_cat = this.oldCategories.find((e) => {
            return e.id == data.category
          })

          switch (data.category) {

            // academico
            case "lNsqjTGpCBF5neQCiGTL":
            //academicos em geral
            case "32Pk3H6J5fhFo5HnJc2W":
              new_category = { "id": "m6BwcqDAZMyVKJZYCWqV", "name": "Acadêmico", "hidden": false, "partner": false }
              break

            // Convidado Internacional
            case "hGVW0Zre6r8FBMVwKM3B":
              new_category = { "id": "rF8cX1XKNweyp6qfxn1U", "name": "Convidado", "hidden": true, "partner": false }
              break;

            // Residentes e especializandos em Medicina
            case "p56d694OC94bEXKJfUHu":
              new_category = { "id": "ALUtUchCqgw72vtDLqfm", "name": "Residente/Especializando em Medicina", "hidden": false, "partner": false }
              break;

            // Não Sócios
            case "EU3sELBmzjCsCb92gruk":
              new_category = { "id": "H2AoWhktluQaWYuPydHC", "name": "Não Sócio", "hidden": false, "partner": false }
              break;


            //////////////////////////////////////////

            // remido
            case "0M00E6TwQxyEWRHE5DFo":
              new_category = { "id": "B8PSEcvlWnLwvwwB0NOR", "name": "Remido", "hidden": false, "partner": true }
              break;
            //  Residente ABRECCV
            case "1R72xzT3l2JfXLLKw2zS":
              new_category = { "id": "9BfCN5Eb94qVk7xRRQuT", "name": "Residente ABRECCV ", "hidden": false, "partner": true }
              break;
            //  SBCEC
            case "FXkIab2o0PJdKECsOB55":
              new_category = { "id": "WmxuckwE0lCTMmkKuY2D", "name": "SBCEC", "hidden": false, "partner": true }
              break;
            //  Titular
            case "HZ2Px06x8F0D9OvoF5Nw":
              new_category = { "id": "9SWyrc8TgRaUEWmfkr95", "name": "Titular", "hidden": false, "partner": true }
              break;
            //  Associado
            case "OMxR2EwjBJlNbb3KsSQ0":
              new_category = { "id": "vPFeWOFfTUGjYKQ4dd3C", "name": "Associado", "hidden": false, "partner": true }
              break;
            //  Aspirante
            case "U6foHhWj1Vlf9AbvPN8L":
              new_category = { "id": "XkNpL8lctQ82mVgSXruw", "name": "Aspirante", "hidden": false, "partner": true }
              break;
            //  Especialista
            case "c3nE7NQ3ESraYyEzhZXn":
              new_category = { "id": "f9IKy8nfJsjvBwO390uT", "name": "Especialista", "hidden": false, "partner": true }
              break;
            //  Honorário
            case "h25kzZ4dL9fq16oYO58Z":
              new_category = { "id": "QztTcPGRDoB08EZkaUci", "name": "Honorário", "hidden": false, "partner": true }
              break;
            // Acadêmicos associados ao DBLACCV
            case "mhKDQ6lsLfUGwqFPgWtY":
              new_category = { "id": "GJ8jZNUOEulUZPVGu9F8", "name": "Acadêmico DBLACCV", "hidden": false, "partner": true }
              break;
            // Sócio DECA
            case "sRpmcwTBmJZYUhyZ5XsB":
              new_category = { "id": "33Y8SMDG3d5u4SdxLOH0", "name": "DECA", "hidden": false, "partner": true }
              break;

          }

          // console.log(data.category)

          let partnerText: any;

          if (new_category.partner)
            partnerText = 'sim'
          else
            partnerText = 'não'

          array.push({
            'id': doc_id,
            'name': data.name,
            'old_category_id': data.category,
            'old_category_name': old_cat.name,
            'new_category_id': new_category.id,
            'new_category_name': new_category.name,
            'socio': partnerText
          })

          // UPDATE 

          /*
          
          this.db.collection('sbccv_members').doc(doc_id)
            .set(Object.assign({},
              { subCategory: new_category }
            ), { merge: true });

          */

        })

        this.display_results = array

      })
  }

  runQuery() {

    const categoryID = "33Y8SMDG3d5u4SdxLOH0"

    console.log(categoryID)

    return this.db.collection<Subcategory>('sbccv_product_cat_price').ref
      .where("categories.id", "array-contains", categoryID)
      .get()
      .then((result) => {

        console.log("done")

        result.forEach((item) => {
          console.log("item.data(): " + JSON.stringify(item.data()))
        })

      })

  }

  loadOldCategories() {
    return this.db.collection<Category>('sbccv_categories', ref => ref
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        result.forEach((item) => {
          this.oldCategories.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name
          })

        })
      })
  }

}
